import { useEffect, useRef, useState } from "react";
import { Send, ShieldCheck, Flag, UserX } from "lucide-react";
import { Avatar } from "@/components/Brand";

function Message({ m, isMod, meId, onKick, onReport }) {
  const own = m.user_id === meId;
  const canAct = !own && !m.simulated && m.user_id !== "sim";
  return (
    <div className="group flex gap-2.5 py-1.5 rise" data-testid="chat-message">
      <Avatar name={m.user_name} src={m.avatar} size={28} className="mt-0.5 shrink-0" />
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-1.5 text-xs">
          <span className={`font-bold ${m.is_moderator ? "text-[hsl(var(--gold))]" : "text-white/80"}`}>{m.user_name}</span>
          {m.is_moderator && <ShieldCheck size={12} className="text-[hsl(var(--gold))]" />}
        </div>
        <p className="text-sm text-white/90 break-words">{m.text}</p>
      </div>
      {canAct && (
        <div className="flex gap-1 opacity-100 md:opacity-0 md:group-hover:opacity-100 transition-opacity">
          <button onClick={() => onReport(m)} className="grid h-7 w-7 place-items-center rounded-full hover:bg-white/10 text-muted-foreground" title="Denunciar" data-testid={`chat-report-${m.id}`}><Flag size={13} /></button>
          {isMod && <button onClick={() => onKick(m)} className="grid h-7 w-7 place-items-center rounded-full hover:bg-red-600 text-red-400 hover:text-white" title="Expulsar" data-testid={`chat-kick-${m.id}`}><UserX size={13} /></button>}
        </div>
      )}
    </div>
  );
}

export function ChatPanel({ messages, onSend, isMod, meId, onKick, onReport, disabled }) {
  const [text, setText] = useState("");
  const endRef = useRef(null);
  useEffect(() => endRef.current?.scrollIntoView({ behavior: "smooth", block: "end" }), [messages.length]);
  const submit = (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    onSend(text);
    setText("");
  };
  return (
    <div className="flex h-full flex-col" data-testid="chat-panel">
      <div className="flex items-center gap-2 border-b border-white/5 px-4 py-3 text-xs text-violet-300">
        <ShieldCheck size={14} /> Chat protegido pelo Guarda-Costas IA
      </div>
      <div className="no-scrollbar flex-1 overflow-y-auto px-4 py-2" data-testid="chat-messages">
        {messages.length === 0 && <p className="py-10 text-center text-sm text-muted-foreground">Seja o primeiro a comentar com carinho.</p>}
        {messages.map((m) => <Message key={m.id} m={m} isMod={isMod} meId={meId} onKick={onKick} onReport={onReport} />)}
        <div ref={endRef} />
      </div>
      <form onSubmit={submit} className="flex gap-2 border-t border-white/5 p-3">
        <input value={text} onChange={(e) => setText(e.target.value)} maxLength={300} disabled={disabled} placeholder={disabled ? "Conectando…" : "Comente com respeito…"}
          className="h-11 flex-1 rounded-full bg-white/5 px-4 text-sm outline-none ring-1 ring-white/10 focus:ring-[hsl(var(--gold))]" data-testid="chat-input-field" />
        <button type="submit" disabled={disabled} className="grid h-11 w-11 place-items-center rounded-full bg-[hsl(var(--gold))] text-[#0B0F17] transition-transform active:scale-95 disabled:opacity-50" data-testid="chat-send-button">
          <Send size={17} />
        </button>
      </form>
    </div>
  );
}
